module.exports = __webpack_public_path__ + "img/luna_logo_main.eb287991.png";